
{
  "familyId": "GET-BREUK-GETALLENLIJN",
  "questions": [
    {
      "id": "GET-BREUK-GETALLENLIJN-001",
      "familyId": "GET-BREUK-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Een getallenlijn loopt van 0 tot 1 en is verdeeld in 4 gelijke stukken. Op welk punt staat ¾?",
      "options": [
        "op het derde streepje",
        "op het tweede streepje",
        "op het vierde streepje",
        "op het eerste streepje"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 0,
            "end": 1,
            "step": 0.25,
            "marked": [0.75],
            "label": "Getallenlijn van 0 tot 1, verdeeld in 4 gelijke stukken",
            "fractionLabels": { "0": "0", "0.25": "¼", "0.5": "½", "0.75": "¾", "1": "1" }
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuken op de getallenlijn",
            "content": "De noemer vertelt in hoeveel stukken de lijn is verdeeld. De teller vertelt hoeveel stukken je telt vanaf 0.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_getallenlijn_kwarten",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De noemer vertelt in hoeveel stukken de lijn is verdeeld, de teller vertelt hoeveel stukken je telt. De noemer is 4, dus de lijn is verdeeld in 4 gelijke stukken. De teller is 3, dus je telt 3 stukken vanaf 0. Het derde streepje = ¾.",
        "solutionSteps": [
          "De noemer is 4 → de lijn is verdeeld in 4 gelijke stukken",
          "De teller is 3 → tel 3 stukken vanaf 0",
          "Het derde streepje = ¾"
        ],
        "distractorExplanations": {
          "0": "Goed! ¾ = 3 van de 4 stukken. Tel 3 streepjes vanaf 0: dat is het derde streepje.",
          "1": "Je dacht waarschijnlijk dat je 2 stukken moest tellen. Maar de teller is 3, niet 2. Het tweede streepje is ²⁄₄ = ½. Onthoud: de teller vertelt hoeveel stukken je telt.",
          "2": "Je dacht waarschijnlijk dat ¾ helemaal aan het einde ligt. Maar het vierde streepje is ⁴⁄₄ = 1 (het einde van de lijn). Onthoud: ¾ is drie kwart, niet vier kwart.",
          "3": "Je dacht waarschijnlijk dat je maar 1 stuk moest tellen. Maar de teller is 3, niet 1. Het eerste streepje is ¼. Onthoud: lees de teller goed — die vertelt hoeveel stukken je telt."
        }
      }
    },
    {
      "id": "GET-BREUK-GETALLENLIJN-002",
      "familyId": "GET-BREUK-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Op een getallenlijn van 0 tot 1, verdeeld in 5 gelijke stukken, welke breuk hoort bij het tweede streepje?",
      "options": [
        "²⁄₅",
        "²⁄₃",
        "⅕",
        "½"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 0,
            "end": 1,
            "step": 0.2,
            "marked": [0.4],
            "label": "Getallenlijn van 0 tot 1, verdeeld in 5 gelijke stukken",
            "fractionLabels": { "0": "0", "0.2": "⅕", "0.4": "⅖", "0.6": "⅗", "0.8": "⅘", "1": "1" }
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van streepje naar breuk",
            "content": "De verdeling bepaalt de noemer (hoeveel stukken). Het streepje bepaalt de teller (hoeveel stukken geteld).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_getallenlijn_vijfden",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De verdeling bepaalt de noemer, het streepje bepaalt de teller. De lijn is verdeeld in 5 stukken, dus de noemer = 5. Het tweede streepje betekent teller = 2. De breuk is ²⁄₅.",
        "solutionSteps": [
          "De lijn is verdeeld in 5 stukken → noemer = 5",
          "Het tweede streepje → teller = 2",
          "De breuk is ²⁄₅"
        ],
        "distractorExplanations": {
          "0": "Goed! 5 stukken → noemer 5. Tweede streepje → teller 2. Breuk = ²⁄₅.",
          "1": "Je dacht waarschijnlijk dat de noemer 3 was. Maar de lijn is verdeeld in 5 stukken, niet 3. Onthoud: de noemer is altijd het totaal aantal stukken op de lijn.",
          "2": "Je dacht waarschijnlijk dat het tweede streepje bij ⅕ hoort. Maar ⅕ is het eerste streepje. Bij het tweede streepje heb je 2 stukken geteld. Onthoud: het streepjenummer = de teller.",
          "3": "Je dacht waarschijnlijk dat de lijn in 2 stukken was verdeeld. Maar de lijn is in 5 stukken verdeeld, dus het tweede streepje = ²⁄₅, niet ½. Onthoud: kijk altijd naar het totaal aantal stukken."
        }
      }
    },
    {
      "id": "GET-BREUK-GETALLENLIJN-003",
      "familyId": "GET-BREUK-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Een cartograaf tekent een getallenlijn van 0 tot 2. Waar op de lijn ligt de breuk ⁵⁄₄?",
      "options": [
        "tussen 1 en 2",
        "tussen 0 en 1",
        "precies op 1",
        "precies op 2"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 0,
            "end": 2,
            "step": 0.25,
            "marked": [1.25],
            "label": "Getallenlijn van 0 tot 2 met ⁵⁄₄ = 1¼",
            "fractionLabels": { "0": "0", "0.25": "¼", "0.5": "½", "0.75": "¾", "1": "1", "1.25": "1¼", "1.5": "1½", "1.75": "1¾", "2": "2" }
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuken groter dan 1",
            "content": "Als de teller groter is dan de noemer, is de breuk groter dan 1. Reken uit: teller ÷ noemer. Voorbeeld: ⁵⁄₄ = 5 ÷ 4 = 1¼.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_getallenlijn_groter_dan_1",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Bepaal eerst of de breuk groter of kleiner is dan 1. Bij ⁵⁄₄ is de teller (5) groter dan de noemer (4), dus de breuk is groter dan 1. ⁵⁄₄ = 1¼ = 1,25. Dat ligt tussen 1 en 2 op de getallenlijn.",
        "solutionSteps": [
          "Vergelijk teller en noemer: 5 > 4 → breuk is groter dan 1",
          "Reken uit: ⁵⁄₄ = 1¼ = 1,25",
          "1,25 ligt tussen 1 en 2"
        ],
        "distractorExplanations": {
          "0": "Goed! ⁵⁄₄ = 1¼ = 1,25. Dat ligt tussen 1 en 2 op de getallenlijn.",
          "1": "Je dacht waarschijnlijk dat alle breuken kleiner zijn dan 1. Maar ⁵⁄₄ heeft een teller (5) die groter is dan de noemer (4), dus de breuk is groter dan 1. Onthoud: teller > noemer = breuk > 1.",
          "2": "Je dacht waarschijnlijk dat ⁵⁄₄ gelijk is aan 1. Maar ⁴⁄₄ = 1, en ⁵⁄₄ = 1 + ¼ = 1,25. Onthoud: pas als teller = noemer is de breuk precies 1.",
          "3": "Je dacht waarschijnlijk dat ⁵⁄₄ gelijk is aan 2. Maar ⁸⁄₄ = 2, en ⁵⁄₄ = 1,25. Onthoud: reken de breuk uit door teller ÷ noemer."
        }
      }
    },
    {
      "id": "GET-BREUK-GETALLENLIJN-004",
      "familyId": "GET-BREUK-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Een getallenlijn van 0 tot 1 is verdeeld in 8 gelijke stukken. Welke breuk ligt precies op de helft?",
      "options": [
        "⁴⁄₈",
        "⁵⁄₈",
        "³⁄₈",
        "⁸⁄₈"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 0,
            "end": 1,
            "step": 0.125,
            "marked": [0.5],
            "highlight": [0.5],
            "label": "Getallenlijn van 0 tot 1, verdeeld in 8 stukken — waar is de helft?",
            "fractionLabels": { "0": "0", "0.125": "⅛", "0.25": "²⁄₈", "0.375": "³⁄₈", "0.5": "⁴⁄₈", "0.625": "⅝", "0.75": "⁶⁄₈", "0.875": "⅞", "1": "1" }
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De helft als breuk",
            "content": "De helft = ½. Zoek de gelijkwaardige breuk met de juiste noemer. Voorbeeld: ½ = ⁴⁄₈ (want 8 ÷ 2 = 4).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_getallenlijn_helft",
      "variantIndex": 4,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De helft van de lijn = ½. Zoek de gelijkwaardige breuk met noemer 8. ½ = ?⁄₈. Reken uit: 8 ÷ 2 = 4, dus ½ = ⁴⁄₈. Het vierde streepje op een lijn verdeeld in 8 stukken is precies de helft.",
        "solutionSteps": [
          "De helft = ½",
          "Zoek gelijkwaardige breuk: ½ = ?⁄₈",
          "8 ÷ 2 = 4, dus ½ = ⁴⁄₈",
          "Het vierde streepje is precies halverwege"
        ],
        "distractorExplanations": {
          "0": "Goed! De helft = ½ = ⁴⁄₈. Op een lijn van 8 stukken is het vierde streepje precies halverwege.",
          "1": "Je dacht waarschijnlijk dat 5 stukken de helft is. Maar ⁵⁄₈ ligt voorbij de helft — 5 van de 8 stukken is meer dan de helft (4 van de 8). Onthoud: de helft van 8 = 4.",
          "2": "Je dacht waarschijnlijk dat 3 stukken de helft is. Maar ³⁄₈ ligt vóór de helft — 3 van de 8 stukken is minder dan de helft (4 van de 8). Onthoud: de helft van 8 = 4.",
          "3": "Je dacht waarschijnlijk dat ⁸⁄₈ de helft is. Maar ⁸⁄₈ = 1, dat is het einde van de lijn. Onthoud: de helft is ⁴⁄₈, niet ⁸⁄₈."
        }
      }
    },
    {
      "id": "GET-BREUK-GETALLENLIJN-005",
      "familyId": "GET-BREUK-GETALLENLIJN",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_getallenlijn",
      "questionType": "multiple_choice",
      "question": "Op een getallenlijn van 0 tot 1, verdeeld in 6 stukken, welke twee breuken zijn gelijk?",
      "options": [
        "²⁄₆ en ⅓",
        "²⁄₆ en ½",
        "³⁄₆ en ⅓",
        "⅙ en ⅓"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 0,
            "end": 1,
            "step": 0.167,
            "marked": [0.333],
            "label": "Getallenlijn van 0 tot 1, verdeeld in 6 stukken — welke breuken vallen samen?",
            "fractionLabels": { "0": "0", "0.167": "⅙", "0.333": "⅓", "0.5": "½", "0.667": "⅔", "0.833": "⅚", "1": "1" }
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gelijkwaardige breuken",
            "content": "Vereenvoudig een breuk door teller en noemer door hetzelfde getal te delen. Als twee breuken dezelfde waarde hebben, liggen ze op hetzelfde punt op de getallenlijn.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_getallenlijn_gelijkwaardig",
      "variantIndex": 5,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Vereenvoudig de breuken en kijk welke op hetzelfde punt liggen. ²⁄₆ vereenvoudigen: 2 en 6 delen door 2 → ⅓. Dus ²⁄₆ = ⅓ — ze liggen op hetzelfde punt op de getallenlijn. Controleer: ²⁄₆ = 2 van de 6 stukken = ⅓ van de lijn ✓.",
        "solutionSteps": [
          "Vereenvoudig ²⁄₆: deel teller en noemer door 2",
          "²⁄₆ = ⅓",
          "Controleer: ²⁄₆ = 2 van de 6 stukken = ⅓ van de lijn ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! ²⁄₆ = ⅓ (beide delen door 2). Ze liggen op hetzelfde punt op de getallenlijn.",
          "1": "Je dacht waarschijnlijk dat ²⁄₆ gelijk is aan ½. Maar ²⁄₆ = ⅓ ≈ 0,33 en ½ = ³⁄₆ = 0,5. Onthoud: vereenvoudig eerst de breuk om te controleren.",
          "2": "Je dacht waarschijnlijk dat ³⁄₆ gelijk is aan ⅓. Maar ³⁄₆ = ½ (delen door 3), niet ⅓. Onthoud: ⅓ = ²⁄₆, en ½ = ³⁄₆.",
          "3": "Je dacht waarschijnlijk dat ⅙ gelijk is aan ⅓. Maar ⅙ is de helft van ⅓. Op de getallenlijn ligt ⅙ op het eerste streepje en ⅓ (= ²⁄₆) op het tweede. Onthoud: ⅙ ≠ ⅓."
        }
      }
    }
  ]
}
